<template>
    <card>
        <card-header>
            <card-overline>Kundenreklamation</card-overline>
        </card-header>
        <card-content>
            <table class="table table--card table--stripped">
                <thead>
                <tr>
                    <th>Eingangsdatum</th>
                    <th>Menge</th>
                    <th>Grund</th>
                    <th>Kommentar</th>
                    <th>berechtigt</th>
                    <th>Status</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="clientComplaint in clientComplaintTable" :key="clientComplaint.index">
                    <td>{{ clientComplaint.complaint_at_string }}</td>
                    <td>{{ clientComplaint.amount }}</td>
                    <td>{{ clientComplaint.complaint_reason_string }}</td>
                    <td>{{ clientComplaint.comment }}</td>
                    <td>{{ clientComplaint.reason_valid_string }}</td>
                    <td>{{ clientComplaint.closed_string }}</td>
                    <td class="small">
                        <form-button icon="document-edit" dense="true"
                                     @click="clientComplaintModal = !clientComplaintModal; editClientComplaint = clientComplaint"/>

                        <form-button type="button" dense="true"
                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.order-information.client-complaint.delete', {'askForQuote': this.askForQuote, 'clientComplaint': clientComplaint.id})"
                                     icon="trash-delete-bin-2" />

                        <form-button icon="documents-file-arrow" dense="true"
                                     @click="this.$emit('forwardClientComplaint', clientComplaint); producerComplaintModal = !producerComplaintModal; editProducerComplaint = clientComplaint; forwardClientComplaint = true"/>
                    </td>
                </tr>
                </tbody>
            </table>

            <modal-dialog title="Kundenreklamation löschen" text="Möchten Sie die Kundenreklamation wirklich löschen?"
                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                          @confirmDialog="deleteMethod"/>

        </card-content>
        <card-content>
            <form-button class="btn--block" color="secondary"
                         @click="clientComplaintModal = !clientComplaintModal" icon="menu-edit-pen-add-circle" :disabled="disabledTab || ! hasClientOutgoingGoods ">neue K-Reklamation
            </form-button>
            <client-complaint-modal :ask-for-quote="askForQuote" :client-complaint="editClientComplaint"
                                    :admin-users="adminUsers"
                                    v-if="clientComplaintModal"
                                    @closeDialog="clientComplaintModal = false; editClientComplaint = null;"/>
        </card-content>
    </card>
</template>

<script>
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import ClientComplaintModal from '@partfactory/Pages/Admin/AskForQuote/Modals/ClientComplaintModal';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';
import Card from '@partfactory/Shared/Card/Card';

export default {
    name: 'ClientComplaint',
    components: {Card, ModalDialog, ClientComplaintModal, FormButton, CardContent, CardOverline, CardHeader},
    props: {
        askForQuote: Object,
        adminUsers: Object,
    },
    data() {
        return {
            clientComplaintModal: false,
            editClientComplaint: null,
            forwardClientComplaint: null,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        clientComplaintTable() {
            let clientComplaints = this.askForQuote?.client_complaints;
            clientComplaints?.forEach(clientComplaint => {
                clientComplaint.complaint_at_string = this.$date(clientComplaint.complaint_at);
                clientComplaint.complaint_reason_string = this.$readableComplaintReason(clientComplaint.complaint_reason_id);
                clientComplaint.creator_string = clientComplaint.creator === 1 ? 'Partfactory' : 'Kunde';
                clientComplaint.reason_valid_string = clientComplaint.reason_valid === -1 ? 'Offen' : clientComplaint.reason_valid === 1 ? 'Ja' : 'Nein';
                clientComplaint.closed_string = clientComplaint.closed === true ? 'geschlossen' : 'offen';

                return clientComplaint;
            });
            return clientComplaints;
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 99);
        },
        hasClientOutgoingGoods() {
            return this.askForQuote.outgoing_goods_client.length > 0;
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
    emits: ['forwardClientComplaint'],
};
</script>
